import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";

import { getWarehouseTransferNote, isReturnToEshopTransfer, transferNoteIdString } from "../../core/warehouseTransferNote.core";
import useGetRetailShopId from "../useGetRetailShopId.hook";
import useRetailShop from "../useRetailShop";

export function useWarehouseTransferNoteDetail() {
  const router = useRouter();
  const rawId = typeof router.query.id === "string" ? router.query.id : "";
  const retailId = useGetRetailShopId();
  const currentRetail = useRetailShop();

  const query = useQuery({
    enabled: !!rawId && !!retailId,
    queryKey: ["warehouseTransferNote", rawId, retailId],
    queryFn: () => getWarehouseTransferNote(rawId),
  });

  const note = query.data;
  const isOutgoing = note ? transferNoteIdString(note.fromRetailShopId) === retailId : false;
  const isIncoming = note ? transferNoteIdString(note.toRetailShopId) === retailId : false;
  const isReturnTransfer = note
    ? isReturnToEshopTransfer(note, currentRetail?.eshopWarehouseId, currentRetail?.warehouseIds)
    : false;
  const editable = note?.status === "draft" || note?.status === "submitted";
  const showLineEditor =
    isOutgoing && editable && !(isReturnTransfer && note?.status === "submitted");

  return {
    ...query,
    rawId,
    retailId,
    note,
    isOutgoing,
    isIncoming,
    isReturnTransfer,
    editable,
    showLineEditor,
  };
}
